import * as yup from 'yup';

const minCharacters = 8;
const maxCharacters = 15;
const regex =
  import.meta.env.VITE_BRAND === 'TradeItaly'
    ? '(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*&])[A-Za-z\\d@$!%*&]{8,15}$'
    : '(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*&])[A-Za-z\\d@$!%*&]{8,15}$';
const passwordErrorMessage =
  import.meta.env.VITE_BRAND === 'TradeItaly'
    ? 'COMMON.ERRORS.PASSWORDS_REGEX_LOWER_UPPER_SYMBOLS'
    : 'COMMON.ERRORS.PASSWORDS_REGEX_LOWER_UPPER_DIGIT_SYMBOLS';

// TODO: improve to use from one place
// (?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*&])[A-Za-z\d@$!%*&]{8,15}$
export const schema = yup
  .object({
    password: yup.string().required('COMMON.ERRORS.REQUIRED_PASSWORD'),
    proposedPassword: yup
      .string()
      .min(minCharacters, 'COMMON.ERRORS.MIN_PASSWORD_LENGTH')
      .max(maxCharacters, 'COMMON.ERRORS.MAX_PASSWORD_LENGTH')
      .matches(new RegExp(regex), passwordErrorMessage)
      .required('COMMON.ERRORS.REQUIRED_PASSWORD'),
    matchProposedPassword: yup
      .string()
      .oneOf(
        [yup.ref('proposedPassword'), ''],
        'COMMON.ERRORS.PASSWORDS_DO_NOT_MATCH'
      )
      .required('COMMON.ERRORS.REQUIRED_PASSWORD'),
  })
  .required();
